import React from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

const NumberFormatting = React.forwardRef(function NumberFormatting(props, ref) {
    const { onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator="."
        decimalSeparator=","
        isNumericString
      />
    );
  });
  
  NumberFormatting.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  export default NumberFormatting;